
export default {
    tip: '9370ef89412706c1601dbb4ec03b311c9a54ebe200d35e89c9fdfeab75271e99',
    name: 'Planned event',
    tabs: [
        {
            tabName: 'Event details',
            i18n_tabName: {
                'en-us': 'Event details'
            },
            rows: [
                {
                    fields: [
                        {
                            type: 'section-header',
                            templateOptions: {
                                label: 'Requestor Details',
                                title: 'Requestor Details',
                                //focus: false,
                                disabled: false,
                                i18n_label: {
                                    'en-us': 'Requestor Details'
                                },
                                i18n_title: {
                                    'en-us': 'Requestor Details'
                                }
                            },
                            conditionalFields: {}
                        }
                    ]
                },
                {

                    fields: [
                        {
                            key: 'requestorNameFirstNameLastName',
                            type: 'input',
                            templateOptions: {
                                label: 'Requestor Name (First Name / Last Name)',
                                placeholder: 'Requestor Name',
                                i18n_label: {
                                    'en-us': 'Requestor Name (First Name / Last Name)'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Requestor Name'
                                },
                                required: true,
                                appearance: 'outline'
                            },
                        }
                    ]

                },
                {
                    fields: [
                        {
                            key: 'requestorZId',
                            type: 'input',
                            templateOptions: {
                                label: 'Requestor zID',
                                placeholder: 'Enter the zID of the requestor',
                                i18n_label: {
                                    'en-us': 'Requestor zID'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Enter the zID of the requestore'
                                },
                                required: true,
                                appearance: 'outline'
                            },
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'requestorEmail',
                            type: 'email-address',
                            templateOptions: {
                                label: 'Requestor Email',
                                type: 'email',
                                placeholder: 'Email address',
                                i18n_label: {
                                    'en-us': 'Requestor Email'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Email address'
                                },
                                required: true,
                                appearance: 'outline'
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'requestorContactNumber',
                            type: 'phone-number',
                            templateOptions: {
                                label: 'Requestor Contact Number',
                                type: 'tel',
                                placeholder: 'Eg: +61234567890',
                                i18n_label: {
                                    'en-us': 'Requestor Contact Number'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Eg: +61234567890'
                                },
                                required: true,
                                appearance: 'outline'
                            },
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'organiserNameAndContactIfDifferentToRequester',
                            type: 'input',
                            templateOptions: {
                                label: 'Organiser Name and Contact',
                                placeholder: 'Organiser Name and Contact (if different to Requester)',
                                i18n_label: {
                                    'en-us': 'Organiser Name and Contact'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Organiser Name and Contact (if different to Requester)'
                                },
                                appearance: 'outline'
                            },
                        }
                    ]
                },
                {
                    fields: [
                        {
                            type: 'section-header',
                            templateOptions: {
                                label: 'Event Details',
                                title: 'Event Details',
                                //focus: false,
                                disabled: false,
                                i18n_label: {
                                    'en-us': 'Event Details'
                                },
                                i18n_title: {
                                    'en-us': 'Event Details'
                                }
                            },
                            conditionalFields: {}
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'eventTitle',
                            type: 'input',
                            templateOptions: {
                                i18n_label: {
                                    'en-us': 'Event Title'
                                },
                                appearance: 'outline'
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'typeCategoryOfEvent',
                            type: 'list-items-select',
                            templateOptions: {
                                required: true,
                                i18n_label: {
                                    'en-us': 'Type / Category of Event'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select your option'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'category',
                                    label: 'Category of Event',
                                    items: [
                                        { value: 'outdoorBooking', label: 'Outdoor booking', items: [] },
                                        { value: 'scheduledEvent', label: 'Scheduled event', items: [] },
                                        { value: 'busBayBooking', label: 'Bus bay booking', items: [] }
                                    ]
                                }
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'eventDescription',
                            type: 'rich-text',
                            templateOptions: {
                                i18n_label: {
                                    'en-us': 'Event description'
                                },
                                appearance: 'outline',
                                rows: 3,
                                autosize: true
                            },
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'startDateTime',
                            type: 'date-time',
                            templateOptions: {
                                label: 'Start date & time',
                                i18n_label: {
                                    'en-us': 'Start date & time'
                                },
                                i18n_placeholder: {
                                    'en-us': 'DD/MM/YYYY hh:mm'
                                },
                                placeholder: 'DD/MM/YYYY hh:mm',
                                appearance: 'outline'
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'endDateTime',
                            type: 'date-time',
                            templateOptions: {
                                label: 'End date & time',
                                placeholder: 'DD/MM/YYYY hh:mm',
                                i18n_label: {
                                    'en-us': 'End date & time'
                                },
                                i18n_placeholder: {
                                    'en-us': 'DD/MM/YYYY hh:mm'
                                },
                                appearance: 'outline'
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'facultyBusUnitArc',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Faculty/Bus Unit/ARC',
                                placeholder: 'Select your option',
                                i18n_label: {
                                    'en-us': 'Faculty/Bus Unit/ARC'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select your option'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'facultyBusUnitArc',
                                    label: 'Faculty/Bus Unit/ARC',
                                    items: [
                                        { label: 'Arc/Club/Society', value: 'arcClubSociety', items: [] },
                                        { label: 'Faculty', value: 'faculty', items: [] },
                                        { label: 'School', value: 'school', items: [] },
                                        { label: 'Unit', value: 'unit', items: [] },
                                        { label: 'Other', value: 'other', items: [] }
                                    ]
                                }
                            },
                            conditionalFields: {
                                readonly: {
                                    value: 'false' as const,
                                    conditions: {}
                                },
                                required: {
                                    value: 'true' as const,
                                    conditions: {}
                                },
                                visibility: {
                                    value: 'true' as const,
                                    conditions: {}
                                }
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'objectChooserField',
                            type: 'object-chooser',
                            templateOptions: {
                                label: 'Object Chooser',
                                placeholder: 'Select your option',
                                i18n_label: {
                                    'en-us': 'Object Chooser'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select your option'
                                },
                                appearance: 'outline',
                                options: [
                                    { label: 'Arc/Club/Society', value: 'arcClubSociety', items: [] },
                                    { label: 'Faculty', value: 'faculty', items: [] },
                                    { label: 'School', value: 'school', items: [] },
                                    { label: 'Unit', value: 'unit', items: [] },
                                    { label: 'Other', value: 'other', items: [] }
                                ]
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'specifyName',
                            type: 'input',
                            templateOptions: {
                                label: 'Specify Name of Faculty/Bus Unit/Arc',
                                i18n_label: {
                                    'en-us': 'Specify Name of Faculty/Bus Unit/Arc'
                                },
                                appearance: 'outline',
                            }
                        }
                    ]
                },
            ],
        },
        {
            tabName: 'Booking details',
            i18n_tabName: {
                'en-us': 'Booking details'
            },
            rows: [
                {
                    fields: [
                        {
                            key: 'location',
                            type: 'list-items-select',
                            templateOptions: {
                                required: true,
                                label: 'Outdoor Location',
                                placeholder: 'Select',
                                i18n_label: {
                                    'en-us': 'Outdoor Location'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'location',
                                    label: 'Location',
                                    items: [
                                        { value: 'f6b30044a934e99387fd56fbe4c9ffa776480fa4c39bbd6fb98ea3950b3c124c', label: 'B26 - Goldstein Courtyard', items: [] },
                                        { value: '15d5de8e1103ededb2867fcf8e422f94734a70e0013970458775470316c2638a', label: 'C20 - Morven Brown Lawn', items: [] },
                                        { value: '07a5271fe0d7d2de2502ac9b728accb70bcecf0a7c03d015ec44d9fd817711f7', label: 'D10 - Alumni Park Lawn (west)', items: [] },
                                        { value: '89311f1a79d081ab3ca42ddd9e35be034d7f2883f9da4b7810d6d28ef3a927bc', label: 'D12 - Alumni Park Lawn (east)', items: [] },
                                        { value: '1d73d3a26ccee199896639f8d42e46b5b415eb47dd46702bad6efb6b1bcf3608', label: 'D21 - Library walkway', items: [] },
                                        { value: 'ae830f407c351c21045fd0f20ac353813a8bfdd20fffabd989d5185035e8fe26', label: 'D25 - Michael Birt Lawn', items: [] },
                                        { value: 'bec5173af49e282a839d23142fb39150576d08cf020090b6b0351b9bbb727797', label: 'E15 - Quadrangle Colonnade', items: [] },
                                        { value: '07c6ccfe7af5f4a1923b6a299cbbb24d2e5ffb299f046075a4e2dd7487c8a1c2', label: 'E16 - Quadrangle Lawn', items: [] },
                                        { value: 'f528cad7c89eeda128e03edd417b932b992244978d0902a1a562c28499e0075b', label: 'E20 - Commerce Courtyard', items: [] },
                                        { value: 'd8420c9369155fe019310aa519d9aff0c460241dbb31c1c1242d85fc2ba83dbd', label: 'E21 - Library Lawn BBQ', items: [] },
                                        { value: 'e69ef68c382de532714225f85d51eb9b7cd543177840938166e9a530d09b5f1a', label: 'G13 - Science Theatre Lawn', items: [] },
                                        { value: '2cf56331ef034380346f1bf4017d7863fbec660aa19f2b48f74bc695733a5a67', label: 'H8 - Physics Courtyard', items: [] },
                                        { value: 'd8332244d9044a81825ef438764d5018d46bcb635707a53ffd50538290c2cc09', label: 'H8 - Sam Cracknell BBQ', items: [] },
                                        { value: '5b03919c0fc46290ecfacdeb1112ae53c81d1a5114dfa3a53361ca6461398d1a', label: 'H13 - Red Centre\, Basement', items: [] },
                                        { value: '6dc27f29464dbc47e6522e50fb5bd8ae425302440610b7aa7e363fa28576b9d4', label: 'H16 - Globe Sculpture Lawn (west)', items: [] },
                                        { value: '2eb41bf4253fd12ce88bb4ec4fbd00c04b1792895abfe205fe55976f2e558b10', label: 'H17 - Globe Sculpture Lawn (east)', items: [] },
                                        {
                                            value: '6d18ee11e4e80c997580380db013b02b1cd53489e9cc50b3609403bbb404e61d', label: 'J15 - Chancellor\'s Garden BBQ', items: []
                                        },
                                        { value: 'd19066ffa3e278193373ac5a5fd7927a5e2196031f030743c867236aa244f4da', label: 'J17 - John Lion\'s Garden', items: [] },
                                        { value: '835465c8b0f656fcfdd3bc67c9c1de89b5d17c90c5f5e07d9feeb3a12c203392', label: 'L13 - Physics Lawn', items: [] },
                                        { value: '7d93246fb196006b5e83290c02edf154cf99a5a105d1af0a1bf46474402aa684', label: 'L14 - Physics Lawn BBQ', items: [] }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'expectedNumberOfAttendees',
                            type: 'number',
                            templateOptions: {
                                label: 'Expected number of attendees',
                                placeholder: '',
                                i18n_label: {
                                    'en-us': 'Expected number of attendees'
                                },
                                i18n_placeholder: {
                                    'en-us': ''
                                },
                                appearance: 'outline',
                                required: true
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'portableToiletsRequired',
                            type: 'checkbox',
                            templateOptions: {
                                label: 'Portable toilets required',
                                i18n_label: {
                                    'en-us': 'Portable toilets required'
                                },
                                indeterminate: false
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        },
                        {
                            key: 'securityDepartmentApproval',
                            type: 'checkbox',
                            templateOptions: {
                                label: 'Security department approval',
                                i18n_label: {
                                    'en-us': 'Security department approval'
                                },
                                indeterminate: false
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'eventPolicySent',
                            type: 'checkbox',
                            templateOptions: {
                                label: 'Event policy sent?',
                                i18n_label: {
                                    'en-us': 'Event policy sent?'
                                },
                                indeterminate: false
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        },
                        {
                            key: 'liquorLicenceRequired',
                            type: 'checkbox',
                            templateOptions: {
                                label: 'Liquor licence required',
                                i18n_label: {
                                    'en-us': 'Liquor licence required'
                                },
                                indeterminate: false
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'ticketedEvent',
                            type: 'checkbox',
                            templateOptions: {
                                label: 'Ticketed event',
                                i18n_label: {
                                    'en-us': 'Ticketed event'
                                },
                                indeterminate: false
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        },
                        {
                            key: 'accessControlRequired',
                            type: 'checkbox',
                            templateOptions: {
                                label: 'Access control required',
                                i18n_label: {
                                    'en-us': 'Access control required'
                                },
                                indeterminate: false
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'recurringEvent',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Is this a recurring event?',
                                placeholder: 'Yes/No',
                                i18n_label: {
                                    'en-us': 'Is this a recurring event?'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Yes/No'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'recurringEvent',
                                    label: 'Recurring event',
                                    items: [
                                        { value: 'no', label: 'No', items: [] },
                                        { value: 'yes', label: 'Yes', items: [] },
                                        { value: 'notApplicable', label: 'Not applicable', items: [] }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'recurringFrequency',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Recurring frequency',
                                placeholder: 'Weekly/Monthly/Yearly',
                                i18n_label: {
                                    'en-us': 'Recurring frequency'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Weekly/Monthly/Yearly'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'recurringFrequency',
                                    label: 'Recurring frequency',
                                    items: [
                                        { value: 'weekly', label: 'Weekly', items: [] },
                                        { value: 'monthly', label: 'Monthly', items: [] },
                                        { value: 'yearly', label: 'Yearly', items: [] }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.recurringEvent !== 'yes' || model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'externalGuestVipInAttendance',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'External Guest / VIP in attendance?',
                                placeholder: 'Yes/No',
                                i18n_label: {
                                    'en-us': 'External Guest / VIP in attendance?'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Yes/No'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'externalGuestVipInAttendance',
                                    label: 'External Guest / VIP in attendance',
                                    items: [
                                        { items: [], value: 'no', label: 'No' },
                                        { items: [], value: 'yes', label: 'Yes' },
                                        { items: [], value: 'notApplicable', label: 'Not applicable' }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'externalGuestVipName',
                            type: 'input',
                            templateOptions: {
                                label: 'External Guest / VIP name',
                                placeholder: 'Enter the full name',
                                i18n_label: {
                                    'en-us': 'External Guest / VIP name'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Enter the full name'
                                },
                                appearance: 'outline',
                            },
                            hideExpression: (model: any) => model.externalGuestVipInAttendance !== 'yes' || model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'accessRequiredForEvent',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Access required for Event?',
                                placeholder: 'Yes/No',
                                i18n_label: {
                                    'en-us': 'Access required for Event?'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Yes/No'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'accessRequiredForEvent',
                                    label: 'Required for Event',
                                    items: [
                                        { value: 'no', label: 'No', items: [] },
                                        { value: 'yes', label: 'Yes', items: [] },
                                        { value: 'notApplicable', label: 'Not applicable', items: [] }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'outdoorBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'location',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Location',
                                placeholder: 'Select Building, Road, or Outdoor space',
                                i18n_label: {
                                    'en-us': 'Location'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select Building, Road, or Outdoor space'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'location',
                                    label: 'Building, Road, or Outdoor space',
                                    items: [
                                        { items: [], value: '5697e7f459873d3084fb30b967a7db78487cdd5e6b7987ba144284c662455627', label: 'A27 - Golf House, 38 Botany St' },
                                        { items: [], value: '336b504c55588c591bf3d7378c03d3ea0d96c4b85f84160140602f124142239a', label: 'AS2 - 2 Arthur Street' },
                                        { items: [], value: 'f92ef4621a69546f4e74b3592d5409e4f42082f9eadbf8e2c7e8cfac109d9a57', label: 'AS4 - 4 Arthur Street' },
                                        { items: [], value: '9715351607e9a95faa0218ab80eec4f7274de237aa887f067239cbaa2282dd74', label: 'AS8 - 8 Arthur Street' },
                                        { items: [], value: 'bb52425772d3467f5c0cf919683d1b843eff5acc8fc5d8b4f67425c1d4e77aed', label: 'AS10 - 10 Arthur Street' },
                                        { items: [], value: 'ce20075c3a2640aec14926f88ffd1691ec783dd2939ffc9c8ac72c9ff3c63c87', label: 'AS12 - 12 Arthur Street' },
                                        { items: [], value: '8b0792ae443840ce8c1c182cad928fedb51d8551bc089987ad01b8bbb40cafcf', label: 'AS14 - 14 Arthur Street' },
                                        { items: [], value: 'e4b87ff3fdc8708770edd07803ec4f69d306f896f013cc85d9222d41f9599986', label: 'AS20 - 20 Arthur Street' },
                                        { items: [], value: 'f76e604d44870f9606da008a064c52f3d8417bf9090a2a58aa5a5b81392b906d', label: 'AS22 - 22 Arthur Street' },
                                        { items: [], value: '61be9f580ccfe68a093f9471ff07d253053e45ca56490e1abe33c5c5ae077f0d', label: 'AS24 - 24 Arthur Street' },
                                        { items: [], value: '95b8c7fc5cf399ba2f3f7afe973b141d90a0a2749a8c70063ecd3f11506d4ecd', label: 'B5 - Fitness and Aquatic Centre' },
                                        { items: [], value: '045316b765cfcc959d6df9a603a84fd2567a5d413fef450f614235a777bae1b0', label: 'B8 - University Terraces' },
                                        { items: [], value: 'd8fe4322ca72855a56929263b95b092fb90675471818a3e0c5fb138bc20cdced', label: 'B10 - UNSW Village' },
                                        { items: [], value: '8e4760964e13b65a1d49ebfa49d9e8d38dbe550965ecacc1bb52fb60b6f8fdf8', label: 'B10B - Campus Village Cafe' },
                                        { items: [], value: 'e2bc6469955def2a1ed50060c155af652e4fe0c0730dc303a3eb1bd9182605bf', label: 'B12B - Substation 22' },
                                        { items: [], value: '2f3e966341f9755b6b733c5cca73219ad0996621f3b275e8320faf4077488976', label: 'B14D - Fig Tree Theatre' },
                                        { items: [], value: '0fe3e218da5ef9e94c21f7436868cc695d7d6820aa1e6413c78d8781380b91a3', label: 'B15 - Old Tote' },
                                        { items: [], value: '3bca2b62b5bae352eb7569902a6d0bf24d2aaa7186050ac0434d6affab326cea', label: 'B16 - Colombo House' },
                                        { items: [], value: '6d8c0ec8a7d630d235ddab4bb61ea27e5a198cb3f93da5322c1348297e540e5e', label: 'B17 - Goldstein College' },
                                        { items: [], value: '36b4c55ed5b4ce2111e8340932423d0c7eaa3fa858275c91ab98f5b06c640ee6', label: 'B18 - Fig Tree Hall' },
                                        { items: [], value: '8cc67b88c2b40f2efc28d20b1d17688ae662671c4fd1321e61ec168ea166643d', label: 'B21 - Repository' },
                                        { items: [], value: 'f6b30044a934e99387fd56fbe4c9ffa776480fa4c39bbd6fb98ea3950b3c124c', label: 'B26 - Goldstein Courtyard' },
                                        { items: [], value: 'cce8a8ce49707bf3e92b1d9186c3b7b33b5489f0bd6d2860fc334cc1c256cb60', label: 'BS22 - Tigger\'s Place' },
                                        { items: [], value: '5a58ee6ef0f8ebd11a9d3e9c937e36c079ca4c46d5ded58f8d75bb764e77c916', label: 'BS26 - 26 Botany Street' },
                                        { items: [], value: 'd40092bac70c0e5ffedc4157ecedc3e7d452bc4eb515e4dad60bbdde66622c3f', label: 'BS30 - 30 Botany Street' },
                                        { items: [], value: 'bd671151a75dfc0c5136a36b942d32c79133883f8b81d70459817729176f6edb', label: 'BS32 - 32 Botany Street' },
                                        { items: [], value: '291d89af17083a8835bb1f0c32d9bf0aa538cc660083fb2f4da6951a9da4bf31', label: 'BS34 - 34-36 Botany Street' },
                                        { items: [], value: '16ffa8bfc1d63fbd469be88969e0f80db4deaf6b733225852aa9a5b89d1007f2', label: 'C6 - International House' },
                                        { items: [], value: '789743c9b9c5a864c4996acee2ebec01e83cdc31cb41ef0d86c05de242ee63f8', label: 'C15 - White House' },
                                        { items: [], value: 'ad6409969d78011a355f14c3f483bf134b773e29d9c8592e6fd59fdedbcf1fb3', label: 'C19 - Garbage Disposal Unit C19' },
                                        { items: [], value: 'ebc9e93df1a27398e14495ab3f6ef27035533e2ee04b3a2510cceb7d7e8ab480', label: 'C20 - Morven Brown' },
                                        { items: [], value: '15d5de8e1103ededb2867fcf8e422f94734a70e0013970458775470316c2638a', label: 'C20 - Morven Brown Lawn' },
                                        { items: [], value: '66eb509bbc7c8d89bbefef9f46c16f3ed07bf84f41a8ac45af49058194103aff', label: 'C21 - Substation 19' },
                                        { items: [], value: '169f205b05a396d6927d032fb36bb3f1ff5a29feed9cdfe497809c362857907f', label: 'C22 - Chancellery' },
                                        { items: [], value: 'ef7477a64e86e98af0aecd20a158222ea37d91367094571c083dee9e415a75f2', label: 'C24 - Clancy Auditorium' },
                                        {
                                            tems: [], value: 'fbbd2db7016b1053464a57e9ffb78daef1b41605f7bcb3d17a8363c81a1f64de', label: 'C25 - Lowy Cancer Research Centre'
                                        },
                                        { tems: [], value: 'f068d652ec89234b3e61ec226cb54a7e2f921752831f56900ac1d94e2742e8d4', label: 'C27 - Wallace Wurth' },
                                        { tems: [], value: '9757c12c2da2b48d5a779e374637affe056bebc6b5d1d7f7dd4be20504b599ba', label: 'D2 - NIDA' },
                                        { tems: [], value: '5ea9cea7022250e7aa874dc0398c1fe1960570d5b55dac9e2b1817dd3026b56b', label: 'D8 - Esme Timbery Creative Practice Lab' },
                                        { tems: [], value: '07a5271fe0d7d2de2502ac9b728accb70bcecf0a7c03d015ec44d9fd817711f7', label: 'D10 - Alumni Park Lawn (west)' },
                                        { tems: [], value: '89311f1a79d081ab3ca42ddd9e35be034d7f2883f9da4b7810d6d28ef3a927bc', label: 'D12 - Alumni Park Lawn (east)' },
                                        { tems: [], value: 'd2e768cfa9371141b0454fc4e76298aa37693c21db38ace3f663dea327528d50', label: 'D14 - UNSW Hall' },
                                        { tems: [], value: '4c31d720719ffe03a59d0ab546605752117e2f0d64d2c7d481960d4d401c7c11', label: 'D16 - Goldstein Hall' },
                                        { tems: [], value: '619be76532aed4dc7dd5d2c5aad665a0f9a2a9b37defb80a8ee171d465428566', label: 'D17 - Basser College' },
                                        { tems: [], value: '9163cbf29ef1927dff305d542e994ea9164433a92f23e912bb9dd4238de09d2d', label: 'D18 - Philip Baxter College' },
                                        { tems: [], value: '1d73d3a26ccee199896639f8d42e46b5b415eb47dd46702bad6efb6b1bcf3608', label: 'D21 - Library walkway' },
                                        { tems: [], value: 'c72e23a2d19b404b4ff0bebc1d109c0cffd63bcaf82486c7a40c32df4b4cbafc', label: 'D23 - Mathews Theatres' },
                                        { tems: [], value: 'ae830f407c351c21045fd0f20ac353813a8bfdd20fffabd989d5185035e8fe26', label: 'D25 - Michael Birt Lawn' },
                                        {
                                            tems: [], value: '2e6366e06bf915de7870b247350d201e05e6741e208ba924c2507737ac0aad9c', label: 'D26 - Biological Sciences - North'
                                        },
                                        { tems: [], value: 'be1181b73291a6c2fcdff63a318904fb8dec929c157eedbe3cfd2a396f03dba1', label: 'E2 - NIDA Parade Theatre' },
                                        { tems: [], value: '85c922591b1102aeda348dc54bb2ddb317113c5adc7215e6153ad1f857874d72', label: 'E4 - Squarehouse' },
                                        { tems: [], value: 'e4f1676f5a3a9db0b55f07dccb90215c32d06b34444ddfa80e16585fd0808e08', label: 'E6 - Roundhouse' },
                                        {
                                            tems: [], value: '754accaa554b2462c1b88993f629e73294b2a5caab8d07d131c203193f9d2fca', label: 'E8 - Science & Engineering (SEB)'
                                        },
                                        { tems: [], value: '84237929004e097cd9832b9570a9e8ae23bf0584ec1fea8c35cff3568a232b30', label: 'E10 - Hilmer Building' },
                                        { tems: [], value: 'b93e4358fd74911a1d75a6443700fb422555b72a357a957f5f4321be15a28afc', label: 'E12 - UNSW Business School' },
                                        { tems: [], value: 'feba3cce540eec2e1d9c625941c07ff97fb9c2282c525ad05710f7db22c24e59', label: 'E14 - Pumproom' },
                                        { tems: [], value: '199fd66d7f18bf44de1e02bdb68915fb17b855ccd100c7ee870a8594e6ac9ad2', label: 'E15 - Quadrangle' },
                                        { tems: [], value: 'bec5173af49e282a839d23142fb39150576d08cf020090b6b0351b9bbb727797', label: 'E15 - Quadrangle Colonnade' },
                                        { tems: [], value: '07c6ccfe7af5f4a1923b6a299cbbb24d2e5ffb299f046075a4e2dd7487c8a1c2', label: 'E16 - Quadrangle Lawn' },
                                        { tems: [], value: '530514be6a6a2a86eaee8e26528d2f7341a1a0cab8943cb73df06342d178571d', label: 'E19 - Central Lecture Block' },
                                        { tems: [], value: 'f528cad7c89eeda128e03edd417b932b992244978d0902a1a562c28499e0075b', label: 'E20 - Commerce Courtyard' },
                                        { tems: [], value: 'd8420c9369155fe019310aa519d9aff0c460241dbb31c1c1242d85fc2ba83dbd', label: 'E21 - Library Lawn BBQ' },
                                        { tems: [], value: '75b7b30d9ca73a6430a70335ab568cd01c2fbfad4aeafdaab717a6cdb90252e5', label: 'E24 - The Pavilions' },
                                        { tems: [], value: 'a69b9bb8480f6c090e2ed5403a71f096f9c43edffa38e0413c4900160bb274f3', label: 'E24A - Mathews Arcade' },
                                        {
                                            tems: [], value: 'd11cc0d5e99b50e35707dd9f696112aefb7ca82962184a8d12682ccb8178a31c', label: 'E26 - Biological Sciences - South'
                                        },
                                        { tems: [], value: '87e66fa0d102d1fa4215a08ef4887b4b24719b350b5f6bd899ef75458184207d', label: 'F8 - Law Building' },
                                        { tems: [], value: '241db1015fbe0a388e0e54084a47f5bc2daa09494653153b24721a6ed86ee653', label: 'F10 - Chemical Sciences' },
                                        { tems: [], value: 'bb1e969a596c8cb25984c236421d4d3e35bc01ebec7ebcec0a2a993c8f93718c', label: 'F12 - Dalton' },
                                        { tems: [], value: '00af5daec6d29f02e639e533af240edd5bfe54710225836aef828f30827188aa', label: 'F13 - Science Theatre' },
                                        { tems: [], value: '111565896f8ac2c0d7b5edd27e432e0438d3ff435a870440074b256eefc553b2', label: 'F17 - Rex Vowels Theatre' },
                                        { tems: [], value: '99f1027f2a0648936ff7c10534e72b37c03879574376d80e0983750e22387188', label: 'F20 - Goodsell' },
                                        { tems: [], value: '2557a08a34eaa25978c721cac981a0febf371c701c5a267ed9049dd20cc221d4', label: 'F21 - Library' },
                                        { tems: [], value: '1d223432b40339d9511f76f115eaa901ec241383fb1fc1024be80cee92f660e0', label: 'F22 - Bank' },
                                        { tems: [], value: '96087abd14c29064dd0ae5abc32e0ac129590f151bb957bedf05f6e6a0366043', label: 'F23 - Mathews' },
                                        { tems: [], value: '7af3d5394e99d5b28fdba2c68b15c264b66fcbf33ea3f3d8c30bab4fc3d4c734', label: 'F25 - Samuels' },
                                        { tems: [], value: 'f268ee1cb3efed026d63880116a607249b1ac82f2462b82a7818ec7f5573c53d', label: 'G6 - Blockhouse' },
                                        { tems: [], value: 'e69ef68c382de532714225f85d51eb9b7cd543177840938166e9a530d09b5f1a', label: 'G13 - Science Theatre Lawn' },
                                        { tems: [], value: '7a7b7bfbbd1956fd15c5c3f47c4ce85a8bd82b901cf4eeecf4b44d2dcbcb6634', label: 'G14 - Robert Webster' },
                                        { tems: [], value: 'cc0bb13fd5013c0b32c91448493c73968b4598f8d5405d472451bcb9fce6d0aa', label: 'G15 - Robert Webster Theatres' },
                                        { tems: [], value: '5a154b41b34634a6bb9c8bcf347af842adaf3120ac808ff42094f5b2ff34dce5', label: 'G17 - Electrical Engineering' },
                                        { tems: [], value: '5dabaf5bae6fa23b2a0f3e7caeb43fe4b77c30aa31453d36de563a38f7066e85', label: 'G19 - John Niland Scientia' },
                                        { tems: [], value: '448e3be0802d73a6f3ce50c921ac676c1c223f4082bcbd19108c465bae044075', label: 'G23 - Solar Industrial Research Facility (SIRF)' },
                                        { tems: [], value: 'ac48b750f7c194e837205462d6c2e186eec3384dbc5f335719d1657d6be06f1b', label: 'G25 - Mini Bus Bay 1 - Gate 11' },
                                        { tems: [], value: '758b251052d51d8aa1bcabaa155de7059b2060d20ac182437d3494203c2d90f4', label: 'G25 - Mini Bus Bay 2 - Gate 11' },
                                        { tems: [], value: '5ead9bfd3e185f4056160197e58f75ab06460353c99b5d90b4c4117bf1053870', label: 'G27 - AGSM' },
                                        { tems: [], value: '7304638f456aee1e925d1ad4bed1c956cf71fddfa495e375d8096eaa362fb982', label: 'H1 - UNSW Regiment' },
                                        { tems: [], value: '6f44c5475c46dd75c05d5f97de20c43b76c6b12c030555cb2f0c3ca01babe481', label: 'H3 - New College Postgraduate Village' },
                                        { tems: [], value: 'df8eaa1249e640759f05669470f5537a0504887a841207e1094b99c646bf74da', label: 'H6 - Tyree Energy Technologies Building (TETB)' },
                                        { tems: [], value: '2cf56331ef034380346f1bf4017d7863fbec660aa19f2b48f74bc695733a5a67', label: 'H8 - Physics Courtyard' },
                                        { tems: [], value: 'd8332244d9044a81825ef438764d5018d46bcb635707a53ffd50538290c2cc09', label: 'H8 - Sam Cracknell BBQ' },
                                        { tems: [], value: '4c9c32fadbb57525fa5833ecd96a481009ef6a081f2218ec0a64e42d1bde92b9', label: 'H8 - Sam Cracknell Pavilion' },
                                        { tems: [], value: '5b03919c0fc46290ecfacdeb1112ae53c81d1a5114dfa3a53361ca6461398d1a', label: 'H13 - Red Centre, Basement' },
                                        { tems: [], value: '571957a7163db52d61c15594cf04e358e9d411e3d48b35ab05d6b7df3522aa4d', label: 'H13 - The Red Centre' },
                                        {
                                            tems: [], value: '6dc27f29464dbc47e6522e50fb5bd8ae425302440610b7aa7e363fa28576b9d4', label: 'H16 - Globe Sculpture Lawn (west)'
                                        },
                                        {
                                            tems: [], value: '2eb41bf4253fd12ce88bb4ec4fbd00c04b1792895abfe205fe55976f2e558b10', label: 'H17 - Globe Sculpture Lawn (east)'
                                        },
                                        { tems: [], value: 'a02b39bbc0fb5ed3e07c0b837051e6175267d876a65d984c480e47a54469132f', label: 'H20 - Civil Engineering' },
                                        { tems: [], value: '8e80d1392ac17ea92a0859179d35049e631945eef0b9d4ef56e3a5a07a677797', label: 'H22 - Vallentine Annexe' },
                                        {
                                            tems: [], value: '749b9dc90e94f11395f8967635e009de12f742509a37ef6f8a45588a1f4c625e', label: 'H22A - Garbage Disposal Unit H22A'
                                        },
                                        { tems: [], value: '7022dac180179234627c792449e8bd9efb7647fc6258740febee5c16d889cb68', label: 'H25 - Botany Street Parking Station' },
                                        { tems: [], value: '29b0ef96c10f2edce1d75e7663688a3ffa7fe94a05563fa2f12d9e56a3381867', label: 'HS30 - 30 High Street' },
                                        { tems: [], value: '3eb0575ffa56988a8015b74865195a64b710f4e7d91ad983d56495c8531af0fb', label: 'HS32 - 32 High Street' },
                                        { tems: [], value: 'eb062266dfbd72e03d63d3c7a572c0a48af9a342854af9a94f9b645c489c1dd3', label: 'HS34 - 34 High Street' },
                                        { tems: [], value: '4f13d1bdc6b77b2fda8d0bfa3a2b62c0cc35ea6971aef7f93d4a6ebce6e75e2b', label: 'HS46 - 46 High Street' },
                                        { tems: [], value: 'ef922c349d82126e940838f767495d1ad51c132876e09f208abd9363de78aad7', label: 'J2 - UNSW Regiment 2' },
                                        { tems: [], value: '61d13afd13d113ab9d54dc68fc14a32126343b91b6ba7fac960abe16ee6a0e9c', label: 'J12 - Newton' },
                                        { tems: [], value: 'f66db1ec512ec9a7a1e04604c177779db095a68cb75515abe449ba01b0f08164', label: 'J14 - Keith Burrows Theatre' },
                                        { tems: [], value: '6d18ee11e4e80c997580380db013b02b1cd53489e9cc50b3609403bbb404e61d', label: 'J15 - Chancellor\'s Garden BBQ' },
                                        { tems: [], value: '67f7fd7e9c5c74d032a24d847bc983fb25f84416d53be70016977d2c08ba2d79', label: 'J17 - Ainsworth Building' },
                                        { tems: [], value: 'd19066ffa3e278193373ac5a5fd7927a5e2196031f030743c867236aa244f4da', label: 'J17 - John Lion\'s Garden' },
                                        { tems: [], value: '08ffb1cd052912548efbb4f9737103fb865cd9fc593bf10b211e097b8b7d35f8', label: 'J18 - Willis Annexe' },
                                        { tems: [], value: '4a2ba1f97dfdf958314a9666267b8eb65105b3ddecc8587e60bf1bcec3cc8619', label: 'K14 - Physics Theatre' },
                                        { tems: [], value: '67d9e69890a81c7d072e1a253602341858e0713ce9eaf163c1c3d23c135c50ca', label: 'K15 - Old Main' },
                                        { tems: [], value: 'd05ec2389f885131f04e470b86b9bc0271dabb9dcb6752c1b9577b9885fb76c8', label: 'K17 - Building K17' },
                                        { tems: [], value: '81024966aa9d911af6a2428fddbfa946382d6cc4f0ba3aec81fb6552448ef4fd', label: 'KS9 - Owl\'s House Building 1' },
                                        { tems: [], value: '77823a21b55c23a9b37e658a7f98a8d305f4ae4d6b53daab4f1e218af98ab673', label: 'L5 - Building L5' },
                                        { tems: [], value: '9dcc3c7b1496a0f8b7a433076205cdf38b43d048c6e5e618fed025108172e6fb', label: 'L6 - New College' },
                                        { tems: [], value: '835465c8b0f656fcfdd3bc67c9c1de89b5d17c90c5f5e07d9feeb3a12c203392', label: 'L13 - Physics Lawn' },
                                        { tems: [], value: '7d93246fb196006b5e83290c02edf154cf99a5a105d1af0a1bf46474402aa684', label: 'L14 - Physics Lawn BBQ' },
                                        { tems: [], value: 'b7aec0f93c0c3e8ca9575ef8d69b7694a728f846fa71a253aa3a60cea41048d5', label: 'M7 - Warrane College' },
                                        { tems: [], value: '921f420615bd797c573e1a0d3e433e5d4cac1d422284ae690fb29dd1fb26c898', label: 'M15 - Rupert Myers' },
                                        { tems: [], value: 'aa17709a34adea2cc43f28e03c3410d61526adeb091101fb4dce941c2554c9a3', label: 'MS48A - Owl\'s House Building 2' },
                                        { tems: [], value: '7479738cf1449b73f247e0851b326fc131181c0b21429c29e011922991a5ef36', label: 'N/A - 1st Avenue West' },
                                        { tems: [], value: '0a3df57edf186ada96413f36d0dae21b97081671f0cf222e1ed4e1e40e892de5', label: 'N/A - Chancellery Lane' },
                                        { tems: [], value: 'c446eb9f15ebd966012308ed14868626b0137c3894c8e378d90ae19890668eb4', label: 'N/A - Chancellery Walk' },
                                        { tems: [], value: '484504d4085ae85d7d212a940fd286e02020741e12205f4ce138ded281e8d443', label: 'N/A - College Road' },
                                        { tems: [], value: 'c1a6d0c25c643a11dc5323f665f30298d592e30ce01b83a6a3c35130c195c763', label: 'N/A - Engineering Road' },
                                        { tems: [], value: '67dfce57c1709592ecdc4209d524f5d5227c8771c87e08991c7ff6841a5b3a33', label: 'N/A - Fig Tree Lane' },
                                        { tems: [], value: 'aa5bb494137ffc4f711b2ac6b86cb26c4270eb99473607975ee77afb12ccf02f', label: 'N/A - G2 Lane' },
                                        { tems: [], value: '00db69883962f1394a8420048f2b2f1a960a266c30101070b005b3959f2633ca', label: 'N/A - Gate 1 - High Street' },
                                        { tems: [], value: '08e62cbc22a6df9d6fc25754af210acfd162afe9420d313b6ec7a1176286aba9', label: 'N/A - Gate 2 - High Street' },
                                        { tems: [], value: '05ddb0ddabef05cc39617edf2d2edfc79cb32b9763ac9a5722446f2e0d7e6edf', label: 'N/A - Gate 2 Avenue' },
                                        { tems: [], value: 'a56727a52b2678f6380f2ed3797c58ab351088ad4061e9d560fbc06252534262', label: 'N/A - Gate 3 - High Street' },
                                        { tems: [], value: '9f446d2c2a2c8ef4ebc93715eeeac7d6f74dfdc0f422682292eabe4547d1da18', label: 'N/A - Gate 4 - High Street' },
                                        { tems: [], value: '0cfd15aef36c75b06723e89ffaef02af915d874d661b3870998649eb21e4843d', label: 'N/A - Gate 5 - High Street' },
                                        { tems: [], value: 'cbfb821da334193d8b979561f65de77383ebbe1977b2eb79514e2bdc3db5b29a', label: 'N/A - Gate 7 - High Street' },
                                        { tems: [], value: 'cdc16d4ccf05b0c5673148a538209878f2e70de8e633bd9cc1e8ff5245fd359e', label: 'N/A - Gate 8 - High Street' },
                                        { tems: [], value: '1e15fe29663a29111236bf9193499d5689afd8d120bc34d0eaad469283c90883', label: 'N/A - Gate 9 - High Street' },
                                        { tems: [], value: 'af43f4a952a3d570dc0a2f31e020a487e864cf13269663e5388c03ac8a184032', label: 'N/A - Gate 11 - Botany Street' },
                                        { tems: [], value: 'd6a11f05d13ab63734a043120e6d29a2ef9a5d6385da4151d4584845f34478fd', label: 'N/A - Gate 13 - Barker Street' },
                                        { tems: [], value: 'c240dcadc1b1d24806d1b00bc3831a33648aadf321ef074127a8728358786f35', label: 'N/A - Gate 14 - Barker Street' },
                                        { tems: [], value: 'e03604ec56c65d7e3320ff2f744b2c467aa5da7bf7eaf4cc6ed7f79c324e94c9', label: 'N/A - International Road' },
                                        { tems: [], value: '57cd4a740bf5df9e1678af66ff8d9df19ff96e2aef1fd4d03f600f2745548348', label: 'N/A - Library Road' },
                                        { tems: [], value: '2d4fd99270032ffaf7450c6d4af72022104644adcd2e4b73533fe4f0cfb81a3a', label: 'N/A - Physics Road' },
                                        { tems: [], value: 'f27a6e3510e5d87d8f0efb1e5322c1e3d11e519c18a8ba0e2cd655c34c5a86f0', label: 'N/A - Science Road' },
                                        { tems: [], value: 'c1781a761af6c7d2646e0e61656b2a1ac9d72bee7908ef133ee42631f0010013', label: 'N/A - Southern Drive' },
                                        { tems: [], value: '80d75af79819472fa541e4428e3ee2fd4825876a501c64a7e6e629e2ec3c80c7', label: 'N/A - Third Avenue' },
                                        { tems: [], value: '4fc93ee207779e30065f4fefbe9deb4ff593611cfa24a7a609627875f4bf54f1', label: 'N/A - Union Road' },
                                        { tems: [], value: '0122b815fa6b5fe012cef801c4bcf4327216edaf659756f404e371b2a7a32527', label: 'N/A - Western Campus Drive' },
                                        { tems: [], value: 'b5616c7b8f910956ce383eff08fa436ef16db6db095428939cd20d634b37c249', label: 'N/A - Willis Lane' },
                                        { tems: [], value: 'b4593809d4e3ba62a0c219411ce8e8b0d698985b40d398c4881d19dcfcf7d1b1', label: 'N8 - House At Pooh Corner' },
                                        { tems: [], value: '1d3ef191a88b5a76876c7a49365a5777b4b43463a9b820b74bd51fd972e6b95c', label: 'N9 - Shalom College' },
                                        { tems: [], value: '025086357f0cc60e5f384d69bdf4e9cf096a8a1918aa03ac44e1e7b2f8fe80c0', label: 'N13 - Barker Apartments' },
                                        { tems: [], value: '0094b4aa6fbdeacc2fae570e4f107092bfcc657260d32a74af08e02954204078', label: 'N14 - Bus Bay 1 - Gate 14' },
                                        { tems: [], value: '69893d62c0570e3c034d495e8932e0cbec0aa6919e0cb5541955df971bd1e04e', label: 'N14 - Bus Bay 2 - Gate 14' },
                                        { tems: [], value: 'cde3dd97d3d5dd588e3a3efb3c2ff628d489331e0fc307e96b6afa234f4e9b22', label: 'N18 - Barker Street Parking Station' },
                                        { tems: [], value: '47eff9a866d0c017f624f80dfc3d693e8a26603da398c5b132d63ecd0af3c516', label: 'O14 - Kanga\'s House' },
                                        { tems: [], value: 'fca26b7044893cb81dd2c07224a718c22e878a423fe1f5505e468599249b7211', label: 'WR41 - 41 Wansey Road' },
                                        { tems: [], value: '680c837ea51c96de8a6134ccb911c34b14d6f3569de97ea55a8fc6b0d2d42840', label: 'WR43 - 43 Wansey Road' },
                                        { tems: [], value: 'f9ee20b3fbe8800f0a717c3797ceb7aa68afa3cbe79bfd736d878d005f72a172', label: 'WR45 - 45 Wansey Road' },
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'levels',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Levels',
                                placeholder: 'Select a level',
                                i18n_label: {
                                    'en-us': 'Levels'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select a level'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'accessRequiredForEvent',
                                    label: 'Required for Event',
                                    items: [
                                        { items: [], value: 'b', label: 'B' },
                                        { items: [], value: 'g', label: 'G' },
                                        { items: [], value: 'l1', label: 'L1' },
                                        { items: [], value: 'l2', label: 'L2' },
                                        { items: [], value: 'l3', label: 'L3' },
                                        { items: [], value: 'l4', label: 'L4' },
                                        { items: [], value: 'l5', label: 'L5' },
                                        { items: [], value: 'l6', label: 'L6' },
                                        { items: [], value: 'l7', label: 'L7' },
                                        { items: [], value: 'l8', label: 'L8' },
                                        { items: [], value: 'l9', label: 'L9' },
                                        { items: [], value: 'l10', label: 'L10' },
                                        { items: [], value: 'l11', label: 'L11' },
                                        { items: [], value: 'l12', label: 'L12' },
                                        { items: [], value: 'l13', label: 'L13' },
                                        { items: [], value: 'l14', label: 'L14' },
                                        { items: [], value: 'l15', label: 'L15' },
                                        { items: [], value: 'l16', label: 'L16' },
                                        { items: [], value: 'l17', label: 'L17' },
                                        { items: [], value: 'l18', label: 'L18' },
                                        { items: [], value: 'l28', label: 'L28' },
                                        { items: [], value: 'lan', label: 'LAN' },
                                        { items: [], value: 'lg', label: 'LG' },
                                        { items: [], value: 'lga', label: 'LGA' },
                                        { items: [], value: 'm', label: 'M' },
                                        { items: [], value: 'r', label: 'R' },
                                        { items: [], value: 'r1', label: 'R1' },
                                        { items: [], value: 'r2', label: 'R2' },
                                        { items: [], value: 'cp', label: 'CP' },
                                        { items: [], value: 'sm', label: 'SM' },
                                        { items: [], value: 'l8M', label: 'L8M' }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'rooms',
                            type: 'input',
                            templateOptions: {
                                label: 'Rooms',
                                placeholder: '',
                                i18n_label: {
                                    'en-us': 'Rooms'
                                },
                                i18n_placeholder: {
                                    'en-us': ''
                                },
                                appearance: 'outline',
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'bollardAccessRequired',
                            type: 'multi-line-text',
                            templateOptions: {
                                label: 'Bollard Access Required?',
                                placeholder: 'If Yes, provide details including dates/time',
                                i18n_label: {
                                    'en-us': 'Bollard Access Required?'
                                },
                                i18n_placeholder: {
                                    'en-us': 'If Yes, provide details including dates/time'
                                },
                                appearance: 'outline',
                                rows: 3,
                                autosize: true
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'roadCarparkOrPedestrianPathwayClosure',
                            type: 'multi-line-text',
                            templateOptions: {
                                label: 'Road, carpark or pedestrian pathway closure?',
                                placeholder: 'If Yes, provide details including dates/time',
                                i18n_label: {
                                    'en-us': 'Road, carpark or pedestrian pathway closure?'
                                },
                                i18n_placeholder: {
                                    'en-us': 'If Yes, provide details including dates/time'
                                },
                                appearance: 'outline',
                                rows: 3,
                                autosize: true
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'barricadesRequired',
                            type: 'multi-line-text',
                            templateOptions: {
                                label: 'Barricades Required?',
                                placeholder: 'If Yes, provide details including dates/time',
                                i18n_label: {
                                    'en-us': 'Barricades Required?'
                                },
                                i18n_placeholder: {
                                    'en-us': 'If Yes, provide details including dates/time'
                                },
                                appearance: 'outline',
                                rows: 3,
                                autosize: true
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'buildingRoomAccessRequired',
                            type: 'multi-line-text',
                            templateOptions: {
                                label: 'Building/Room Access Required?',
                                placeholder: 'If Yes, provide details including dates/time',
                                i18n_label: {
                                    'en-us': 'Building/Room Access Required?'
                                },
                                i18n_placeholder: {
                                    'en-us': 'If Yes, provide details including dates/time'
                                },
                                appearance: 'outline',
                                rows: 3,
                                autosize: true
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'numberAndTypeOfVehicles',
                            type: 'rich-text',
                            templateOptions: {
                                label: 'Number and Type of Vehicles',
                                placeholder: 'Provide details of types of vehicle and how many',
                                i18n_label: {
                                    'en-us': 'Number and Type of Vehicles'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Provide details of types of vehicle and how many'
                                },
                                appearance: 'outline',
                                rows: 3,
                                autosize: true
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'scheduledEvent'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'additionalRequirements',
                            type: 'rich-text',
                            templateOptions: {
                                label: 'Additional Requirements e.g. bollards/room access, Power/lighting etc.',
                                placeholder: 'If Yes, provide details including dates/time',
                                i18n_label: {
                                    'en-us': 'Additional Requirements e.g. bollards/room access, Power/lighting etc.'
                                },
                                i18n_placeholder: {
                                    'en-us': 'If Yes, provide details including dates/time'
                                },
                                appearance: 'outline',
                                rows: 3,
                                autosize: true
                            },
                            hideExpression: (model: any) => {
                                return model.typeCategoryOfEvent !== 'scheduledEvent' && model.typeCategoryOfEvent !== 'outdoorBooking';
                            }
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'location',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Bus Bay Location',
                                placeholder: 'Select',
                                i18n_label: {
                                    'en-us': 'Bus Bay Location'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select'
                                },
                                appearance: 'outline',
                                listItems: {
                                    value: 'accessRequiredForEvent',
                                    label: 'Required for Event',
                                    items: [
                                        {
                                            items: [], value: 'ac48b750f7c194e837205462d6c2e186eec3384dbc5f335719d1657d6be06f1b', label: 'G25 - Mini Bus Bay 1 - Gate 11'
                                        },
                                        {
                                            items: [], value: '758b251052d51d8aa1bcabaa155de7059b2060d20ac182437d3494203c2d90f4', label: 'G25 - Mini Bus Bay 2 - Gate 11'
                                        },
                                        { items: [], value: '0094b4aa6fbdeacc2fae570e4f107092bfcc657260d32a74af08e02954204078', label: 'N14 - Bus Bay 1 - Gate 14' },
                                        { items: [], value: '69893d62c0570e3c034d495e8932e0cbec0aa6919e0cb5541955df971bd1e04e', label: 'N14 - Bus Bay 2 - Gate 14' }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'busBayBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'nameOfExternalOrganisationSchool',
                            type: 'input',
                            templateOptions: {
                                label: 'Name of external organisation / school',
                                placeholder: 'Enter the name of the organisation or school',
                                i18n_label: {
                                    'en-us': 'Name of external organisation / school'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Enter the name of the organisation or school'
                                },
                                appearance: 'outline',
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'busBayBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'typeOfBus',
                            type: 'list-items-select',
                            templateOptions: {
                                label: 'Type of bus',
                                placeholder: 'Select a bus type',
                                i18n_label: {
                                    'en-us': 'Type of bus'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Select a bus type'
                                },
                                appearance: 'outline',
                                listItems: {
                                    label: 'Type of bus',
                                    value: 'typeOfBus',
                                    items: [
                                        { items: [], value: 'coach52Seater', label: 'Coach (52 seater)' },
                                        { items: [], value: 'minibus22Seater', label: 'Minibus (22 seater)' },
                                        { items: [], value: 'other', label: 'Other' }
                                    ]
                                }
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'busBayBooking'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'otherTypeOfBus',
                            type: 'input',
                            templateOptions: {
                                label: 'Other bus type',
                                placeholder: 'Enter details of the other bus type',
                                i18n_label: {
                                    'en-us': 'Other bus type'
                                },
                                i18n_placeholder: {
                                    'en-us': 'Enter details of the other bus type'
                                },
                                appearance: 'outline',
                                required: true
                            },
                            hideExpression: (model: any) => model.typeCategoryOfEvent !== 'busBayBooking' || model.typeOfBus !== 'other'
                        }
                    ]
                },
                {
                    fields: [
                        {
                            key: 'attachments',
                            type: 'file-upload',
                            templateOptions: {
                                label: 'Documents e.g. TMP, RSA certs, Risk assessments etc',
                                i18n_label: {
                                    'en-us': 'Documents e.g. TMP, RSA certs, Risk assessments etc'
                                },
                                appearance: 'outline'
                            }
                        }
                    ]
                }
            ]
        }
    ],
    formSpecVersion: '1',
    background: '',
    logo: '',
    logoPositioning: null,
};
